import React from 'react';
import { Box, Typography } from '@mui/material';
import { SxProps } from '@mui/system';
import {
    actionsWidth,
    dragHandleWidth,
    libelleWidth,
    puWidth,
    quantiteWidth,
    rubriqueWidth,
    tauxWidth,
    ttcWidth,
    puLibelle,
    tauxLibelle,
    rubriqueLibelle,
    libelleLibelle,
    quantiteLibelle,
    ttcLibelle,
} from '../Article/functions';

export type ArticlePrefacturationHeaderProps = {
    sx?: SxProps;
};
const ArticlePrefacturationHeader: React.FunctionComponent<ArticlePrefacturationHeaderProps> =
    function ({ sx }) {
        return (
            <Box
                sx={{
                    display: {
                        xs: 'none',
                        sm: 'none',
                        md: 'none',
                        lg: 'flex',
                        xl: 'flex',
                    },

                    flexDirection: 'row',
                    width: '100%',
                    padding: '4px 8px 4px 4px',
                    gap: '0',
                    alignItems: 'center',
                    color: 'text.gris50',
                    ...sx,
                }}
            >
                <Box sx={{ width: dragHandleWidth }} />
                <Box
                    sx={{
                        justifyContent: 'center',
                        display: 'flex',
                        width: rubriqueWidth,
                    }}
                >
                    <Box
                        sx={{
                            borderRadius: '12px',
                            textAlign: 'center',
                            padding: '8px 10px',
                            margin: '5px 0px',
                            alignItems: 'center',
                            display: 'inline-block',
                        }}
                    >
                        <Typography variant="l2dtableCell">{rubriqueLibelle}</Typography>
                    </Box>
                </Box>
                <Box
                    sx={{
                        padding: '10px 0px',
                        width: libelleWidth,
                    }}
                >
                    <Typography variant="l2dtableCell">{libelleLibelle}</Typography>
                </Box>
                <Box
                    sx={{
                        padding: '10px 0px',
                        width: quantiteWidth,
                    }}
                >
                    <Typography variant="l2dtableCell">{quantiteLibelle}</Typography>
                </Box>
                <Box
                    sx={{
                        padding: '10px 10px 10px 0px',
                        width: puWidth,
                        textAlign: 'right',
                    }}
                >
                    <Typography variant="l2dtableCell">{puLibelle}</Typography>
                </Box>
                <Box
                    sx={{
                        padding: '10px 0px',
                        width: tauxWidth,
                        textAlign: 'center',
                    }}
                >
                    <Typography variant="l2dtableCell">{tauxLibelle}</Typography>
                </Box>
                <Box
                    sx={{
                        padding: '10px 0px',
                        width: ttcWidth,
                        textAlign: 'right',
                    }}
                >
                    <Typography variant="l2dtableCell">{ttcLibelle}</Typography>
                </Box>
                <Box sx={{ textAlign: 'right', padding: '10px 0px', width: actionsWidth }} />
            </Box>
        );
    };

export default ArticlePrefacturationHeader;
